<div class="report-generator">
  <div class="report-card">
    <div class="report-card-header">
      <mat-icon>assessment</mat-icon>
      <h3>Rapporter</h3>
    </div>
    <div class="report-card-body">
      @if (missingLocation) {
      <div class="error-banner">
        Kunne ikke finde lokation i URL. Rapport-generatoren skal bruges på en
        stations-side (<code>/lokation/…</code>).
      </div>
      } @if (!showWizard && !missingLocation) {
      <div class="start-panel">
        @if (reportJustGenerated) {
        <p class="success-banner">
          Rapporten er genereret og downloadet. Du kan oprette en ny rapport
          nedenfor.
        </p>
        }
        <button mat-raised-button color="primary" (click)="openModal()">
          <mat-icon>add</mat-icon>
          {{ reportJustGenerated ? "Opret ny rapport" : "Generér rapport" }}
        </button>
      </div>
      } @if (showWizard) {
      <app-duna-report-wizard
        [context]="wizardContext"
        (cancelled)="onWizardCancelled()"
        (generated)="onWizardGenerated()"
      >
      </app-duna-report-wizard>
      }
    </div>
  </div>
</div>
